import {IssueTemplateItem} from './IssueTemplateItem'
import type {IssueTemplateListNode} from './template-list-query-types'
import {IssueCreationKind} from './utils/model'
import {getTemplateUrl} from './utils/urls'

export type IssueTemplateRowFragment = Pick<IssueTemplateListNode, 'name' | 'about' | 'filename'>

type IssueTemplateProps = {
  onTemplateSelected?: (filename: string, kind: IssueCreationKind) => void
  template: IssueTemplateRowFragment
  nameWithOwner: string
}

export const IssueTemplateRow = ({nameWithOwner, template, onTemplateSelected}: IssueTemplateProps) => {
  return (
    <IssueTemplateItem
      filename={template.filename}
      onTemplateSelected={filename => onTemplateSelected?.(filename, IssueCreationKind.IssueTemplate)}
      name={template.name}
      about={template.about}
      link={onTemplateSelected ? undefined : getTemplateUrl(nameWithOwner, template.filename)}
    />
  )
}
